export default {
  light: '300',
  normal: '400',
  semibold: '600',
  bold: '800'
}



// WEBPACK FOOTER //
// ./styles/settings/fontweights.js